import  router from '@/router/index.js';
import { authenticationService } from '@/services/authentication.service.js';
import pbiService from '@/services/pbi.service.js';

// eslint-disable-next-line
const user = JSON.parse(localStorage.getItem('login_info'));

let state = null;
if(user && (Date.parse(user.expiresTime) > Date.now())) {
    state = { status: { loggedIn: true }, user };
} else {
    state = { status: { loggedIn: false }, user: null };
}
const actions = {

    async getAzureAccessToken({dispatch, commit}) {
        return await pbiService.getAccessToken();
    },

    logout({ commit }) {
        authenticationService.logout();
        commit('logout');
    },

    // register({ dispatch, commit }, user) {
    //     commit('registerRequest', user);
    //     authenticationService.register(user)
    //         .then(
    //             user => {
    //                 commit('registerSuccess', user);
    //                 router.push('/login');
    //                 setTimeout(() => {
    //                     // hiển thị message thành công sau redirect sang trang 
    //                     dispatch('alert/success', 'Registration successful', { root: true });
                       
    //                 })
    //             },
    //             error => {
    //                 commit('registerFailure', error);
    //                 dispatch('alert/error', error, { root: true });
    //             }
    //         );
    // }
};
const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state, user) {
        state.status = { registering: true };
    },
    registerSuccess(state, user) {
        state.status = {};
    },

    registerFailure(state, error) {
        state.status = {};
    }
};

export const authentication = {
    namespaced: true,
    state,
    actions,
    mutations
};